// extracted by mini-css-extract-plugin
export default {"root":"TableActions_root__IhlHl","action":"TableActions_action__wN0ti","linkAction":"TableActions_linkAction__bh5Fu"};